import { Component, Input } from '@angular/core';
import { PrescriptionStatus } from 'src/app/enums/prescription-status';
import { MedicalCareRecord } from 'src/app/models/medical-care-record';
import { MedicalOrder } from 'src/app/models/medical-order';
import { Prescription } from 'src/app/models/prescription';

const { SENT, SENT_UNVALIDATED } = PrescriptionStatus;

@Component({
  selector: 'app-call-files-list',
  templateUrl: './call-files-list.component.html',
  styleUrls: ['./call-files-list.component.css'],
  standalone: false
})
export class CallFilesListComponent {
  @Input() set prescriptions(value: Prescription[] | undefined) {
    this._prescriptions = value;
    this.hasAnyPrescriptionSent = !!value?.some((p) => p.status === SENT || p.status === SENT_UNVALIDATED);
  }

  @Input() medicalOrders: MedicalOrder[] | undefined;
  @Input() medicalCareRecord: MedicalCareRecord | undefined;
  @Input() instructions: string[] = [];
  @Input() urls: string[] = [];

  private _prescriptions: Prescription[] | undefined;
  hasAnyPrescriptionSent = false;
  readonly prescriptionStatus = PrescriptionStatus;

  get prescriptions(): Prescription[] | undefined {
    return this._prescriptions;
  }

  getUrl(criteria: string): void {
    const url = this.urls?.find((u) => u.includes(criteria));
    if (url) {
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      a.href = url;
      a.target = '_blank';
      a.download = 'File';
      a.click();
    }
  }
}
